export const GOODS = [
  { name: 'Bread',     w: 2, m: 1, e: 1, demandQty: 17 },
  { name: 'Shoes',     w: 3, m: 2, e: 1, demandQty: 5 },
  { name: 'Medicine',  w: 1, m: 3, e: 2, demandQty: 14 },
  { name: 'Steel',     w: 2, m: 2, e: 3, demandQty: 7 },
  { name: 'Furniture', w: 4, m: 3, e: 2, demandQty: 5 },
];

// Scenario demand total, derived from demandQty (not the other way around).
// demandQty is authoritative scenario data: the largest integer quantities,
// in roughly the ratio 35/10/30/15/10, that stay within the resource pool
// below (verified cost: 97 workers, 98 materials, 81 energy).
export const DEMAND_TOTAL = GOODS.reduce((sum, g) => sum + g.demandQty, 0); // 48

export const TOTAL = 100;

// Slider ceiling per good, shared between the planning UI and any chart
// that needs to scale against the same range.
export const SLIDER_MAX = 25;

export function calculateUsed(qty) {
  return {
    w: GOODS.reduce((s, g, i) => s + g.w * qty[i], 0),
    m: GOODS.reduce((s, g, i) => s + g.m * qty[i], 0),
    e: GOODS.reduce((s, g, i) => s + g.e * qty[i], 0),
  };
}

export function calculateResults(qty) {
  const rows = GOODS.map((g, i) => {
    const gap = qty[i] - g.demandQty;
    return { ...g, qty: qty[i], gap };
  });

  const totalShortfall = rows.reduce((s, r) => s + Math.max(0, -r.gap), 0);
  const totalSurplus = rows.reduce((s, r) => s + Math.max(0, r.gap), 0);

  const raw = 100 * (1 - (totalShortfall + totalSurplus) / DEMAND_TOTAL);
  const score = Math.max(0, Math.min(100, Math.round(raw)));

  const worstShortage = rows
    .filter(r => r.gap < 0)
    .sort((a, b) => a.gap - b.gap)[0];

  const impactStatement = worstShortage
    ? worstShortage.name === 'Medicine'
      ? `Your plan left ${Math.abs(worstShortage.gap)} units of medicine demand unmet. In a larger economy, persistent errors of this kind would mean delayed or denied access to care.`
      : worstShortage.name === 'Bread'
      ? `Your plan left ${Math.abs(worstShortage.gap)} units of bread demand unmet. Repeated at scale, such shortages would create rationing, queues, and hardship.`
      : `Your plan left ${Math.abs(worstShortage.gap)} units of ${worstShortage.name.toLowerCase()} demand unmet, constraining downstream production and consumption that depended on it.`
    : `You met demand well across all five goods. Real economies must coordinate this across millions of goods, not five.`;

  return { score, rows, totalShortfall, totalSurplus, worstShortage, impactStatement };
}
